import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-label="Para iade garantisi" className="bg-white" data-id="element-104" data-mp="1o46konudlsx5">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center lg:py-20" style={{
      paddingTop: "11px",
      paddingBottom: "23px"
    }} data-id="element-105" data-mp="1o5zsi6gq6j6q">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-perf/15" data-id="element-106" data-mp="1x5d16wx0z3qe">
          <ShieldCheckIcon className="h-8 w-8 text-perf-deep" aria-hidden="true" data-id="element-107" data-mp="19fsimf4sa8hn" />
        </span>
        <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-108" data-mp="14gpecwwmo6aq">
          7 Günlük Para İade Garantisi
        </h2>
        <p className="mt-3 text-lg font-semibold text-navy" data-id="element-109" data-mp="1edu3n5lrshvr">Satın alma kararınızı güvenle verin.</p>
        <p className="mt-5 text-[17px] leading-relaxed text-navy/75" data-id="element-110" data-mp="qo9f876uksf3">
          İlk 7 gün içerisinde UZUN MESAFE TRİATLON SİSTEMİ™ ürününün ihtiyaçlarınıza uygun olmadığına
          karar verirseniz, geçerli garanti koşulları kapsamında para iadesi talep edebilirsiniz.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-111" data-mp="oxp13zm9l0zb">
          Garanti şartları doğrultusunda satın alma bedelinizin %100'ü iade edilir. Böylece sistemi
          değerlendirirken uzun vadeli bir finansal taahhütte bulunmanız gerekmez.
        </p>
        <p className="mt-6 text-sm font-bold uppercase tracking-[0.2em] text-navy" data-id="element-112" data-mp="12pmv137emqaw">SIGMA SMART™</p>
      </div>
    </section>;
}